import { baseApi } from '../../lib/baseApi';
import type { CurrentUser, ApiUser } from '../../lib/apiTypes';

export const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getCurrentUser: build.query<CurrentUser, void>({
      // skipAuthRedirect: AuthBootstrap renders inline Access Denied / retry
      // screens for this call; the apiClient's blanket 401/403 redirect would
      // navigate away before they ever showed.
      query: () => ({ operation: 'GetCurrentUser', skipAuthRedirect: true }),
      providesTags: [{ type: 'User', id: 'CURRENT' }],
    }),

    listUsers: build.query<ApiUser[], void>({
      query: () => ({ operation: 'ListUsers' }),
      transformResponse: (response: { users: ApiUser[] }) => response.users,
      providesTags: (result) =>
        result
          ? [
              ...result.map((u) => ({ type: 'User' as const, id: u.alias })),
              { type: 'User' as const, id: 'LIST' },
            ]
          : [{ type: 'User' as const, id: 'LIST' }],
    }),

    setAdmin: build.mutation<ApiUser, { alias: string }>({
      query: ({ alias }) => ({
        operation: 'SetAdmin',
        body: { alias },
      }),
      invalidatesTags: [
        { type: 'User', id: 'LIST' },
        { type: 'User', id: 'CURRENT' },
        { type: 'Audit', id: 'LIST' },
      ],
    }),

    removeAdmin: build.mutation<ApiUser, { alias: string }>({
      query: ({ alias }) => ({
        operation: 'RemoveAdmin',
        body: { alias },
      }),
      invalidatesTags: [
        { type: 'User', id: 'LIST' },
        { type: 'User', id: 'CURRENT' },
        { type: 'Audit', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetCurrentUserQuery,
  useListUsersQuery,
  useSetAdminMutation,
  useRemoveAdminMutation,
} = authApi;
